module.exports = __webpack_public_path__ + "media/images/lightbox/close-19c6ef9ffb7680c95361121bc39e61a6.png";